import React, { useState } from "react";

const AdmissionProcessStep = ({
  ProcessArrow,
  step,
  index,
  selectedIndexs,
}) => {
  const [processArrowShow, setProcessArrowShow] = useState(true);
  useState(() => {
    selectedIndexs?.map((selectedIndex) => {
      if (selectedIndex === index) {
        setProcessArrowShow(false);
      }
    });
  });
  return (
    <div className="col-lg-4 col-xl-3 col-md-6 col-12">
      <div className="admission-process-single card-1">
        <div className="process-arrow-icon">
          {/* <img src={ProcessArrow} alt="#" /> */}
          {processArrowShow ? <img src={ProcessArrow} alt="#" /> : ""}
        </div>
        <div className="process-icon">
          <img src={step.img} alt="#" />
        </div>
        <div className="process-content">
          <span className="process-step">Step-{index + 1}</span>
          <h4 className="process-content-title">{step.title}</h4>
        </div>
      </div>
    </div>
  );
};

export default AdmissionProcessStep;
